import PageSection from "@components/PageSection";
import React from "react";
import { ContentItem } from "@typed/content";
import ResourceList from "@components/FlatList/ResourceList";

interface IProps {
  techSheetList: ContentItem[];
}
const Info = ({ techSheetList }: IProps) => (
  <PageSection sectionName="Application & Technical Information">
    <ResourceList items={techSheetList} />
</PageSection>
);

export default Info;
